// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es7.weak-set.from.js
// module id = ../../node_modules/core-js/modules/es7.weak-set.from.js
// module chunks = 18